// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-5d2a5dab] .card {\n  display: flex !important;\n  margin-bottom: 0;\n}\n.bg-color[data-v-5d2a5dab] {\n  background-color: white !important;\n}\n@media (min-width: 768px) {\n.programs-list[data-v-5d2a5dab] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
